import clsx from "clsx";

import { ComponentBaseProps } from "[root]/src/lib";

type CardFooterProps = Pick<ComponentBaseProps, "children" | "className">;

export const CardFooter = ({ children, className }: CardFooterProps) => (
  <footer className={clsx("card-footer", className)}>{children}</footer>
);
